import { useMemo } from 'react';
import { MobileMenuFixedStyled, MobileMenuStyled } from './styled/MobileMenuStyled';
import { useSelector } from 'react-redux';
import { makeSelectAppLoggedIn } from '../../../app/appSelectors';
import { MOBILE_MENU_ITEM_CONFIGS_LIST } from './getMobileMenuItemConfigs';
import { DisconnectModal } from '../../../components/DisconnectModal/DisconnectModal';
import MobileMenuItem from './MobileMenuItem';


function MobileMenu() {
    const isLoggedIn = useSelector(makeSelectAppLoggedIn());

    const mobileMenuList = useMemo(() => MOBILE_MENU_ITEM_CONFIGS_LIST
            .map(config => <MobileMenuItem config={config} key={config.to}/>),
        []);

    if (!isLoggedIn) {
        return null;
    }

    return <MobileMenuFixedStyled>
        <MobileMenuStyled>
            {mobileMenuList}
        </MobileMenuStyled>
        <DisconnectModal/>
    </MobileMenuFixedStyled>;
}

export default MobileMenu;
